import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from './providers/theme-provider';
import { AuthProvider } from './providers/auth-provider';
import { AnalyticsProvider } from './providers/analytics-provider';
import { AppProviders } from './providers/app-providers';
import i18n from '@shared/i18n/config/i18n';
import Router from './router';
import './styles/globals.css';

function App(): React.ReactElement {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AnalyticsProvider>
              <AppProviders>
                <Router />
              </AppProviders>
            </AnalyticsProvider>
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
